<script>
import Feature from '@/components/app/shared/Feature'
import FadeSlideUp from '@/components/transitions/FadeSlideUp'
import { features } from '@/data/app'

export default {
  components: { Feature, FadeSlideUp },
	props: {
		panelWidth: { type: Number, required: true },
	},
	data() {
		return {
			features,
		}
	},
}
</script>

<template>
	<section class="py-16 pl-28 pr-20 flex justify-center">
		<div class="flex flex-col gap-20 w-full max-w-screen-xl">
			<FadeSlideUp>
				<div
					class="flex flex-col items-start"
					:style="`max-width: min(542px, 100% - ${panelWidth + 110}px);`"
				>
					<h2
						class="text-black font-inter font-bold text-pretty leading-tight"
						style="font-size: 32px;"
					>Take control of your fractional jet ownership with our new App</h2>
					<span
						class="text-grey-700 font-header text-lg font-medium leading-relaxed uppercase text-pretty tracking-widest"
						style="margin-top: 32px;"
					>Connect, share and fly smarter.</span>
				</div>
			</FadeSlideUp>
			<ul
				class="grid grid-cols-4"
				style="gap: 71px;"
			>
				<Feature
					v-for="feature in features"
					:key="feature.key"
					:imgSrc="feature.imgSrc"
					:title="feature.title"
					:description="feature.description"
					:new="feature.new"
				/>
			</ul>
		</div>
	</section>
</template>
